import React, { useEffect, useState } from 'react';
import '../css/regokas.css';
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    TableContainer,
    TextField
} from '@mui/material';
import { RxCross2 } from 'react-icons/rx';
import Loader from '../components/loader';
import Edit from '../images/headericon/Edit.svg';
import Error1 from '../images/Error.svg';

const MarketPlace = (props) => {
    const { redux } = props;
    const userType = localStorage.getItem("name");
    const [showModels, setShowModels] = useState(false); // false by default
    const [error, setError] = useState('');
    const [disabledValue, setDisabledValue] = useState(false);
    const [topHeightModal, setTopHeightModal] = useState('0px');
    const [distributors, setDistributors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [siPercentage, setSiPercentage] = useState('');
    const [setPrice, setSetPrice] = useState('');
    const [selectedAppId, setSelectedAppId] = useState(null);


    const onOpenModel = (appId) => {

        const selectedApp = distributors.find((item) => item.id === appId);

        setShowModels(true);
        setSelectedAppId(appId);
        setSiPercentage(selectedApp?.siPercentage?.toString() || '');
        setSetPrice(selectedApp?.setPrice?.toString() || '');

    };


    const onCloseModel = (event) => {

        // Reset all required fields
        setShowModels(false);
        setSetPrice('');
        setSiPercentage('');
        setSelectedAppId(null);
        setError('');

    };


    const crossErrorFullMsg = () => {
        setError('');
    };

    const fetchDistributors = () => {
        setLoading(true);
        fetch('/we/distributorsApp/')
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then((data) => {
                setDistributors(data || []);
                setLoading(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
    };


    useEffect(() => {
        fetchDistributors();
    }, []);


    const onAddClickHandler = async () => {
        if (!setPrice || !siPercentage) {
            setError('All fields are required');
            return;
        }
        // const selectedApp = distributors.find((item) => item.id === selectedAppId);

        // if (Number(setPrice) < Number(selectedApp.cost_per_download)) {
        //     alert("Please enter an amount greater than minimum price");
        //     return;
        // }
        const selectedApp = distributors.find(item => item.id === selectedAppId);
        const basePrice = selectedApp?.price ?? selectedApp?.cost_per_download;

        if (Number(setPrice) < Number(basePrice)) {
            alert("Please enter an amount greater than the minimum price");
            return;
        }


        const payload = {
            app_id: selectedAppId,
            setPrice: parseFloat(setPrice),
            siPercentage: parseFloat(siPercentage),
        };

        try {
            setLoading(true); // show loader

            const response = await fetch('/we/distributorsApp/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': localStorage.getItem('csrftoken')
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) throw new Error('Failed to submit data');

            const data = await response.json();

            alert('Price successfully added! ✅');
            onCloseModel();
            fetchDistributors(); // refresh the table data
        } catch (err) {
            setError(err.message || 'Something went wrong');
        } finally {
            setLoading(false); // hide loader
        }

    };

    return (
        <div className="container dashboardContainer ">
            {loading ? <Loader /> : null}
            <h3>Dear {redux?.globalVar?.reUserNameStyle}, Listed below are your existing market place</h3>
            <h6 className="mb-3 mt-0">To add a new price click on, "Add New price"</h6>

            <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table className={"tablecontent"}>
                    <TableHead>
                        <TableRow >
                            <TableCell sx={{ fontSize: '11px', color: 'white' }}>Application</TableCell>
                            <TableCell sx={{ fontSize: '11px', color: 'white' }}>Minimum Price</TableCell>
                            <TableCell sx={{ fontSize: '11px', color: 'white' }}>Default Price</TableCell>
                            <TableCell sx={{ fontSize: '11px', color: 'white' }}>Price Set By Distributor</TableCell>
                            <TableCell sx={{ fontSize: '11px', color: 'white' }}>SI Percentage(%)</TableCell>
                            {userType == 3 && (
                                <TableCell sx={{ fontSize: '11px', color: 'white' }} >Set Price</TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {distributors.map((user) => {
                            const loggedInEmail = localStorage.getItem("email") || "";

                            // Check if user has permission for this app
                            const hasPermission =
                                Array.isArray(user.permissions) &&
                                user.permissions.some(p => {
                                    return p.si_email == loggedInEmail
                                });


                            return (
                                <TableRow key={user.id}>
                                    <TableCell sx={{ fontSize: '11px' }}>{user.name}</TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>
                                        {user.cost_per_download != null && user.cost_per_download !== ''
                                            ? `$${parseFloat(user.cost_per_download).toFixed(2)}`
                                            : 'NA'}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>
                                        {user.price != null && user.price !== 0
                                            ? `$${parseFloat(user.price).toFixed(2)}`
                                            : 'NA'}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>
                                        {user.setPrice != null && user.setPrice !== ''
                                            ? `$${Number(user.setPrice).toFixed(2)}`
                                            : 'NA'}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '11px' }}>
                                        {user.siPercentage != null && user.siPercentage !== ''
                                            ? `${user.siPercentage}%`
                                            : 'NA'}
                                    </TableCell>
                                    {userType == 3 && (
                                        <TableCell>
                                            <img
                                                src={Edit}
                                                alt="edit"
                                                onClick={() => {
                                                    if (!hasPermission) {
                                                        onOpenModel(user.id);
                                                    }
                                                }}
                                                style={{
                                                    cursor: !hasPermission ? 'pointer' : 'not-allowed',
                                                    opacity: !hasPermission ? 1 : 0.5,
                                                }}
                                                title={
                                                    !hasPermission
                                                        ? 'Set Price'
                                                        : 'You do not have permission to set the price for this app.'
                                                }
                                            />
                                        </TableCell>
                                    )}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>


            {showModels && (
                <div
                    className="selfmodal fade in modal-dialog-centered"
                    style={{ alignItems: 'center', top: topHeightModal }}
                    aria-hidden="false"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div
                        className="selfmodal-dialog"
                        style={{
                            width: props.windowWidth > 760 ? '50%' : '60%',
                        }}
                    >
                        <div className="selfmodal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" onClick={onCloseModel}>
                                    &times;
                                </button>
                                <h3 className="modal-title">Add New Price </h3>
                                <h6>Please fill in the details to add new price and SI percentage.</h6>

                                <div className={error ? 'errormsgbox' : 'errormsgbox errormsgboxnone'}>
                                    <div className="inblksucc">
                                        <img src={Error1} alt="error" />
                                    </div>
                                    <div className="inblksucc1">
                                        {error} !
                                        <a className="successmsgcross">
                                            <RxCross2 size={20} onClick={crossErrorFullMsg} />
                                        </a>
                                    </div>
                                </div>

                                {/* TextFields */}
                                <div style={{ padding: '0 20px', marginTop: '15px' }}>
                                    <TextField
                                        type="text"
                                        fullWidth
                                        label="SI Percentage(%)"
                                        variant="standard"
                                        size="small"
                                        margin="dense"
                                        value={siPercentage}
                                        onChange={(e) => {
                                            const rawValue = e.target.value;

                                            // Allow only digits, no letters or special characters
                                            if (/^\d{0,3}$/.test(rawValue)) {
                                                const numberValue = Number(rawValue);

                                                // Prevent leading zeros and enforce 0–100 range
                                                if (rawValue === "" || (numberValue >= 0 && numberValue <= 100)) {
                                                    const cleanedValue = rawValue.replace(/^0+(?=\d)/, "");
                                                    setSiPercentage(cleanedValue);
                                                }
                                            }
                                        }}
                                        inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 3,
                                        }}
                                        helperText={siPercentage > 100 ? "Max 100%" : ""}
                                    />
                                    <TextField
                                        type="text"
                                        fullWidth
                                        label="Set Price"
                                        variant="standard"
                                        size="small"
                                        margin="dense"
                                        value={setPrice === "" ? "" : Number(setPrice).toLocaleString("en-IN")}
                                        onChange={(e) => {
                                            const rawValue = e.target.value.replace(/,/g, "");

                                            // Allow only up to 7 digits
                                            if (/^\d{0,7}$/.test(rawValue)) {
                                                const cleaned = rawValue.replace(/^0+(?=\d)/, "");
                                                setSetPrice(cleaned); // Store even if it's temporarily invalid (e.g., '1')
                                            }
                                        }}
                                        // placeholder={
                                        //     selectedAppId && distributors.find(item => item.id === selectedAppId)?.cost_per_download
                                        //         ? `Enter amount more than $${Number(distributors.find(item => item.id === selectedAppId)?.cost_per_download).toLocaleString("en-IN")}`
                                        //         : "Enter set price"
                                        // }
                                        placeholder={
                                            (() => {
                                                const selected = distributors.find(item => item.id === selectedAppId);
                                                if (selected) {
                                                    if (selected.price) {
                                                        return `Enter amount more than $${Number(selected.price).toLocaleString("en-IN")}`;
                                                    } else if (selected.cost_per_download) {
                                                        return `Enter amount more than $${Number(selected.cost_per_download).toLocaleString("en-IN")}`;
                                                    }
                                                }
                                                return "Enter set price";
                                            })()
                                        }

                                        inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                        }}
                                        error={
                                            setPrice !== "" &&
                                            selectedAppId &&
                                            Number(setPrice) <= Number(distributors.find(item => item.id === selectedAppId)?.cost_per_download || 0)
                                        }
                                        helperText={
                                            setPrice.length > 7
                                                ? "Max 7 digits allowed"
                                                : setPrice !== "" &&
                                                    selectedAppId &&
                                                    Number(setPrice) <= Number(distributors.find(item => item.id === selectedAppId)?.cost_per_download || 0)
                                                    ? `Must be more than $${Number(distributors.find(item => item.id === selectedAppId)?.cost_per_download).toLocaleString("en-IN")}`
                                                    : ""
                                        }
                                    />
                                </div>

                            </div>
                            <div
                                className="modal-footer align-btn-mobile"
                                style={{
                                    marginTop: '3%',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: '10px',
                                }}
                            >
                                <div className="btn allbtn" onClick={onCloseModel}>
                                    Cancel
                                </div>
                                <div
                                    className="btn allbtn"
                                    style={{ backgroundColor: '#4286f5' }}
                                    onClick={() => onAddClickHandler('add')}
                                    disabled={disabledValue}
                                >
                                    Request
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default MarketPlace;
